import React from "react";
import { Box } from "../../Box";
import { Button } from "../../Button";
import { Icon } from "../../Icon";
export const CloseButton = ({ ariaLabel, onClose }) => (React.createElement(Box, { position: "absolute", right: "24px", top: "16px" },
    React.createElement(Button, { "aria-label": ariaLabel, onClick: onClose, size: "icon", textStyle: "whiteIcon", type: "button", variant: "iconWithoutBorder" },
        React.createElement(Icon, { size: "16", src: "Close" }))));
